import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box } from '@gemini/core';
import { LinkBox } from '@seo/linkbox';
import { ExternalLinkIcon } from '@gemini/icons';
import Container from '@/components/structure/Container';
import { linksBox } from '@/services/linksBox';
import { useTranslation } from '@/hooks/useTranslations';
export const LinksBox = () => {
    if (!linksBox)
        return null;
    const { t } = useTranslation();
    const { links, type } = linksBox[0];
    return (_jsx(Box, { backgroundColor: "color.background.light", paddingTop: {
            'breakpoint.base': 'spacing.32',
            'breakpoint.lg': 'spacing.64',
        }, paddingBottom: "spacing.16", children: _jsxs(Container, { children: [_jsx(LinkBox, { name: "", links: links, type: type }), [...Array(5)].map((_, index) => (_jsxs(Box, { typography: "typography.body.14.regular", color: "color.content.subdued.default", marginTop: index === 0 ? 'spacing.56' : 'spacing.8', display: "flex", alignItems: "center", gap: "spacing.4", children: [index === 4 && _jsx(ExternalLinkIcon, { size: 'sizing.16' }), t(`fsrbo.generic.footer.mention${index + 1}`)] }, index)))] }) }));
};
